// Bridges ui.ts's cast handler to GameScene for a Bind·Entropy cast -- crosses
// the faced object and the marked Source over, so that a later Transfer of
// Entropy naming either one is served by the other. The displacement itself
// isn't triggered from here and does not run at settle time at all: it is a
// redirection applied inside `applyTransferEffect`, via
// rune-lab/src/sim/entropyBind.ts's `displacedEntropyLocus`. This cast only
// writes the cluster that makes the pair an end of a link. See EntropyBindDef
// in rune-lab/src/sim/types.ts for the full mechanic.
//
// The event/result shapes themselves live in rune-lab/src/sim/casts.ts with the
// handler that consumes them, and are re-exported here unchanged, so every
// import site reads them from this module -- the same shape every other
// operator effect's bridge already has.
import { EntropyBindEffectEvent, EntropyBindEffectResult } from '../../rune-lab/src/sim/casts';

export type { EntropyBindEffectEvent, EntropyBindEffectResult };

type Handler = (event: EntropyBindEffectEvent) => EntropyBindEffectResult;

let handler: Handler | null = null;

export function onEntropyBindEffect(fn: Handler): void {
  handler = fn;
}

export function triggerEntropyBindEffect(event: EntropyBindEffectEvent): EntropyBindEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '', sourceWasSelf: true, coupled: false };
}
